import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  State,
  getWebsitesAction,
  getIsWebsitesLoading,
  getAccountsAction,
  getAccountsEntities,
  selectWebsiteEntities,
  upsertWebsiteAction,
  getIsWebsitesUpsertings,
  deleteWebsiteAction,
  getIsWebsiteDeleting,
} from '../../store';
import { map, filter, tap, takeUntil } from 'rxjs/operators';
import { combineLatest, Subject, ReplaySubject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'ecom-edit-website',
  templateUrl: './edit-website.component.html',
  styleUrls: ['./edit-website.component.scss'],
})
export class EditWebsiteComponent implements OnInit, OnDestroy {
  isLoading$ = this.store.pipe(select(getIsWebsitesLoading));
  isUpserting$ = this.store.pipe(select(getIsWebsitesUpsertings));
  isWebsiteDeleting$ = this.store.pipe(select(getIsWebsiteDeleting));
  websites$ = this.store.pipe(select(selectWebsiteEntities));
  accounts$ = this.store.pipe(select(getAccountsEntities));
  website$ = combineLatest([
    this.websites$,
    this.route.url,
    this.accounts$,
  ]).pipe(
    filter(([_, [__, { path: websiteId }]]) => !!websiteId),
    map(([websites, [_, { path: websiteId }], accounts]) => {
      const website = websites[websiteId];
      if (website) {
        return { ...website, account: accounts[website.accountId] };
      }
    }),
  );

  form = this.fb.group({
    websiteId: null,
    rc4Secret: null,
    sectionId: [null, Validators.required],
    accountId: [null, Validators.required],
    websiteName: [null, Validators.required],
    fr_client_id: [null, Validators.required],
    fr_token: [null, Validators.required],
    script: [null, Validators.required],
  });

  constructor(
    private readonly store: Store<State>,
    private readonly route: ActivatedRoute,
    private readonly fb: FormBuilder,
  ) {}
  onDestroy$ = new Subject();
  saveWatcher$ = new ReplaySubject();

  ngOnInit() {
    this.store.dispatch(getWebsitesAction());
    this.store.dispatch(getAccountsAction());

    this.website$
      .pipe(
        takeUntil(this.onDestroy$),
        filter((website) => !!website),
        tap(
          ({
            websiteId,
            rc4Secret = null,
            sectionId,
            accountId,
            websiteName,
            script = null,
            account: { fr_client_id, fr_token } = {
              fr_client_id: null,
              fr_token: null,
            },
          }) => {
            this.form.setValue({
              websiteId,
              rc4Secret,
              sectionId,
              accountId,
              websiteName,
              fr_client_id,
              fr_token,
              script,
            });
          },
        ),
      )
      .subscribe();

    this.isUpserting$
      .pipe(
        takeUntil(this.onDestroy$),
        tap((isUpserting) => {
          if (isUpserting) {
            this.form.disable();
          } else {
            this.form.enable();
          }
        }),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.unsubscribe();
  }

  save() {
    this.store.dispatch(
      upsertWebsiteAction({
        payload: this.form.value,
      }),
    );
  }

  deleteWebsite() {
    if (this.form.value.websiteId) {
      this.store.dispatch(
        deleteWebsiteAction({ payload: this.form.value.websiteId }),
      );
    }
  }
}
